var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "room_icons--container" }, [
    _c(
      "span",
      {
        staticClass:
          "room_icons--icon room_icons--icon-availability room_icons--icon-available tooltip-dock-top",
        class: {
          "room_icons--icon-unavailable": !_vm.iconsAvailable.anyRoomType,
          "icon-low-inventory": _vm.$store.getters.roomTypeTotalAvailable(
            _vm.roomAvailabilityData
          ),
        },
        attrs: {
          "data-tooltip": _vm.availabilityTooltip,
          "aria-label": _vm.availabilityTooltip,
        },
      },
      [
        _c("svg", [
          _c("use", {
            attrs: {
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              "xlink:href": "#symbol_calendar_valid",
            },
          }),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.icons["non-smoking"]
      ? _c(
          "span",
          {
            staticClass:
              "room_icons--icon room_icons--icon-non_smoking tooltip-dock-top",
            class: {
              "room_icons--icon-unavailable":
                !_vm.iconsAvailable["non-smoking"],
            },
            attrs: {
              "data-tooltip": _vm.iconsAvailable["non-smoking"]
                ? "Non-Smoking Available"
                : "Non-Smoking Sold Out",
              "aria-label": _vm.iconsAvailable["non-smoking"]
                ? "Non-Smoking Available"
                : "Non-Smoking Sold Out",
            },
          },
          [
            _c("svg", [
              _c("use", {
                attrs: {
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "xlink:href": "#symbol_non_smoking",
                },
              }),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.icons.smoking
      ? _c(
          "span",
          {
            staticClass:
              "room_icons--icon room_icons--icon-smoking tooltip-dock-top",
            class: {
              "room_icons--icon-unavailable": !_vm.iconsAvailable.smoking,
            },
            attrs: {
              "data-tooltip": _vm.iconsAvailable.smoking
                ? "Smoking Available"
                : "Smoking Sold Out",
              "aria-label": _vm.iconsAvailable.smoking
                ? "Smoking Available"
                : "Smoking Sold Out",
            },
          },
          [
            _c("svg", [
              _c("use", {
                attrs: {
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "xlink:href": "#symbol_smoking",
                },
              }),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.icons.ada
      ? _c(
          "a",
          {
            staticClass:
              "room_icons--icon room_icons--icon-ada tooltip-dock-top",
            class: { "room_icons--icon-unavailable": !_vm.iconsAvailable.ada },
            attrs: {
              "data-tooltip": _vm.iconsAvailable.ada
                ? "Click for " + _vm.page.TITLE + " Accessibility Options"
                : "Accessibility Options Sold Out",
              "aria-label": _vm.iconsAvailable.ada
                ? "Click for " + _vm.page.TITLE + " Accessibility Options"
                : "Accessibility Options Sold Out",
              title: _vm.iconsAvailable.ada
                ? "Click for " + _vm.page.TITLE + " Accessibility Options"
                : "Accessibility Options Sold Out",
              href: "#",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.showAdaVariants.apply(null, arguments)
              },
            },
          },
          [
            _c("svg", [
              _c("use", {
                attrs: {
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "xlink:href": "#symbol_accessible",
                },
              }),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }